export default "__VITE_ASSET__D4iEs7Lz__"